import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './StoreDetail.css';

// Maps the site's size labels to the size suffix used in Stripe product names, e.g. "Eyes Tee [XL]"
const SIZE_TO_STRIPE_SUFFIX = {
  'SMALL': 'S',
  'MEDIUM': 'M',
  'LARGE': 'L',
  'X LARGE': 'XL',
  'XX LARGE': 'XXL',
};

const products = {
  'kurupt-tee': {
    name: 'Kurupt FM Heavy Tee',
    stripeProductName: 'Kurupt Tee',
    image: require('../assets/store/KURUPT TEE.png'),
    galleryImages: [require('../assets/store/KURUPT TEE BACK.png')],
    subtitle: 'NEW!',
    subtitleColor: 'green',
    price: '£35',
    promoImages: [
      'KURUPT_PROMO_1.jpg',
      'KURUPT_PROMO_2.jpg',
      'KURUPT_PROMO_4.jpg',
    ],
    sizes: Object.keys(SIZE_TO_STRIPE_SUFFIX),
  },
  'og-tee': {
    name: 'OG HEAVY TEE',
    stripeProductName: 'Travs Presents Tee',
    image: require('../assets/store/OG Tee.png'),
    subtitle: 'NEW!',
    subtitleColor: 'white',
    price: '£30',
    promoImages: [
      'OG_TEE_PROMO_0.jpg',
      'OG_TEE_PROMO_1.jpg',
      'OG_TEE_PROMO_2.jpg',
      'OG_TEE_PROMO_3.jpg'
    ],
    buyLinks: {
      'SMALL': 'https://buy.stripe.com/00w28r4sRgxc0EN3iC3VC0A',
      'MEDIUM': 'https://buy.stripe.com/5kQ8wP6AZ1Ciafng5o3VC0B',
      'LARGE': 'https://buy.stripe.com/8x214n2kJ4OugDLdXg3VC0C',
      'X LARGE': 'https://buy.stripe.com/9B6cN5bVjcgW0EN7yS3VC0D',
      'XX LARGE': 'https://buy.stripe.com/8x228r2kJ4OugDLf1k3VC0E'
    }
  },
  'eyes-tee': {
    name: 'EYES HEAVY TEE',
    stripeProductName: 'Eyes Tee',
    image: require('../assets/store/Eyes Tee.png'),
    subtitle: 'NEW!',
    subtitleColor: 'red',
    price: '£30',
    promoImages: [
      'EYES_TEE_PROMO_0.jpg',
      'EYES_TEE_PROMO_1.jpg',
      'EYES_TEE_PROMO_2.jpg',
      'EYES_TEE_PROMO_3.jpg',
      'EYES_TEE_PROMO_4.jpg'
    ],
    buyLinks: {
      'SMALL': 'https://buy.stripe.com/5kQ8wP1gFgxc9bjg5o3VC0v',
      'MEDIUM': 'https://buy.stripe.com/dRm4gz4sRdl0cnv9H03VC0w',
      'LARGE': 'https://buy.stripe.com/6oUaEXe3r1Ciafn5qK3VC0x',
      'X LARGE': 'https://buy.stripe.com/bJecN50cBbcSdrzaL43VC0y',
      'XX LARGE': 'https://buy.stripe.com/9B6eVdbVjft8bjr1au3VC0z'
    }
  },
  'clash-tee': {
    name: 'CLASH TEE',
    stripeProductName: 'Clash x TravsPresents Limited Edition Tee',
    image: require('../assets/store/Clash Mag Tee.png'),
    subtitle: 'SOLD OUT',
    soldOut: true, // permanently sold out - all sizes unselectable regardless of Stripe status
    price: '£25',
    promoImages: [
      'CLASH_TEE_PROMO_1.jpg',
      'CLASH_TEE_PROMO_2.jpg',
      'CLASH_TEE_PROMO_3.jpg'
    ],
    buyLinks: {
      'SMALL': 'https://buy.stripe.com/4gw4hb7wOeBWfE46oE',
      'MEDIUM': 'https://buy.stripe.com/00g6pj8AS2Te4ZqdR7',
      'LARGE': 'https://buy.stripe.com/5kA9Bv3gygK41NedR8',
      'X LARGE': 'https://buy.stripe.com/00g8xreZg65qcrS3cv',
      'XX LARGE': 'https://buy.stripe.com/3csdRL8ASfG0crSeVe'
    }
  },
  'satellite-tee': {
    name: 'SATELLITE HEAVY TEE',
    stripeProductName: 'Satellite Tee',
    image: require('../assets/store/SATELLITE TEE FRONT.png'),
    subtitle: 'NEW!',
    subtitleColor: 'green',
    price: '£30',
    promoImages: [
      //REPLACE WITH ACTUAL PROMO IMAGES WHEN AVAILABLE
      'SATELLITE TEE BACK.png',
      'SATELLITE_TEE_PROMO_2.jpg',
      'SATELLITE_TEE_PROMO_3.jpg',
      'SATELLITE_TEE_PROMO_4.jpg',
    ],
    sizeChart: {
      columns: ['Size', 'Chest (cm)', 'Length (cm)', 'Width (cm)'],
      rows: [
        ['XS', '46', '68', '43'],
        ['S', '49', '71', '46'],
        ['M', '52', '74', '49'],
        ['L', '55', '77', '52'],
        ['XL', '58', '80', '55'],
        ['2XL', '61', '83', '58'],
        ['3XL', '64', '86', '61']
      ]
    },
    buyLinks: {
      'SMALL': 'https://buy.stripe.com/7sYaEX5wV3Kq1IR5qK3VC0u',
      'MEDIUM': 'https://buy.stripe.com/dRm7sLe3rgxc9bj2ey3VC0t',
      'LARGE': 'https://buy.stripe.com/3cI7sL5wV2Gm3QZ1au3VC0s',
      'X LARGE': 'https://buy.stripe.com/9B6eVd2kJ94KgDL3iC3VC0r',
      'XX LARGE': 'https://buy.stripe.com/8x23cve3rft8fzHdXg3VC0q'
    }
  }
};

const StoreDetail = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [selectedSize, setSelectedSize] = useState('');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showSizeChart, setShowSizeChart] = useState(false);
  const [cartConfirmation, setCartConfirmation] = useState(false);
  const [archivedProductNames, setArchivedProductNames] = useState([]);
  const product = products[productId];

  useEffect(() => {
    fetch('/.netlify/functions/product-availability')
      .then((res) => (res.ok ? res.json() : { archivedProductNames: [] }))
      .then((data) => setArchivedProductNames(data.archivedProductNames || []))
      .catch((err) => console.error('Failed to load product availability:', err));
  }, []);

  if (!product) {
    return <div>Product not found</div>;
  }

  // Create array of all images (main + promo)
  const allImages = [
    product.image,
    ...(product.galleryImages || []),
    ...product.promoImages.map(image => require(`../assets/store/promo/${image}`))
  ];

  const isSizeSoldOut = (size) => {
    if (product.soldOut) return true;
    const suffix = SIZE_TO_STRIPE_SUFFIX[size];
    return archivedProductNames.includes(`${product.stripeProductName} [${suffix}]`);
  };

  const handleSizeChange = (e) => {
    setSelectedSize(e.target.value);
  };

  const handleAddToCart = () => {
    if (selectedSize && !isSizeSoldOut(selectedSize)) {
      addToCart({
        productId,
        size: selectedSize,
        name: product.name,
        price: product.price,
        image: product.image,
        quantity: 1,
      });
      setCartConfirmation(true);
      setTimeout(() => setCartConfirmation(false), 3000);
      setSelectedSize('');
    }
  };

  const handleBuyNow = () => {
    if (!selectedSize || isSizeSoldOut(selectedSize)) return;

    const buyLink = product.buyLinks?.[selectedSize];
    if (buyLink) {
      window.location.href = buyLink;
      return;
    }

    addToCart({
      productId,
      size: selectedSize,
      name: product.name,
      price: product.price,
      image: product.image,
      quantity: 1,
    });
    navigate('/cart');
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => 
      prev === allImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => 
      prev === 0 ? allImages.length - 1 : prev - 1
    );
  };

  const handleSizeChartClick = (e) => {
    e.preventDefault();
    setShowSizeChart(true);
  };

  return (
    <div className="store-detail-container">
      <Link to="/store" className="back-button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 12H5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 19L5 12L12 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Back to Store
      </Link>
      
      <div className="store-detail-content">
        {/* Left side - Image carousel */}
        <div className="product-image-section">
          <div className="main-image-container">
            <button className="carousel-arrow left" onClick={prevImage}>&#10094;</button>
            <img 
              src={allImages[currentImageIndex]} 
              alt={`${product.name} view ${currentImageIndex + 1}`} 
              className="main-product-image"
            />
            <button className="carousel-arrow right" onClick={nextImage}>&#10095;</button>
          </div>
          <div className="thumbnail-container">
            {allImages.map((image, index) => (
              <div 
                key={index}
                className={`thumbnail ${currentImageIndex === index ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              >
                <img src={image} alt={`${product.name} thumbnail ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        {/* Right side - Product details */}
        <div className="product-details-section">
          <h1 className="product-name">{product.name}</h1>
          <p className="product-subtitle" style={{ color: product.subtitleColor }}>{product.subtitle}</p>
          <p className="product-price">{product.price}</p>
          
          <div className="size-selection">
            <p className="choose-size-text">CHOOSE A SIZE</p>
            <div className="size-selection-container">
              <select 
                value={selectedSize}
                onChange={handleSizeChange}
                className="size-dropdown"
              >
                <option value="">SELECT SIZE</option>
                {(product.sizes || Object.keys(product.buyLinks)).map((size) => (
                  <option key={size} value={size} disabled={isSizeSoldOut(size)}>
                    {size}{isSizeSoldOut(size) ? ' (SOLD OUT)' : ''}
                  </option>
                ))}
              </select>
              <div className="button-group">
                <button 
                  className="add-to-cart-button"
                  onClick={handleAddToCart}
                  disabled={!selectedSize || isSizeSoldOut(selectedSize)}
                >
                  ADD TO CART
                </button>
                <button 
                  className="buy-now-button"
                  onClick={handleBuyNow}
                  disabled={!selectedSize || isSizeSoldOut(selectedSize)}
                >
                  BUY NOW
                </button>
              </div>
            </div>
            {cartConfirmation && (
              <div className="cart-confirmation-message">
                ✓ Item added to cart!
              </div>
            )}
          </div>

          <div className="technical-details">
            <a href="#" className="technical-details-link" onClick={handleSizeChartClick}>SIZE CHART</a>
          </div>
        </div>
      </div>

      {/* Size Chart Modal */}
      {showSizeChart && (
        <div className="size-chart-modal">
          <div className="size-chart-content">
            <button className="close-modal" onClick={() => setShowSizeChart(false)}>&times;</button>
            <h2>Size Chart</h2>
            <div className="size-chart-table">
              <table>
                <thead>
                  <tr>
                    {product.sizeChart ? 
                      product.sizeChart.columns.map((col, idx) => <th key={idx}>{col}</th>) :
                      <>
                        <th>Size</th>
                        <th>Chest</th>
                        <th>Waist</th>
                        <th>Neck</th>
                        <th>Sleeve</th>
                      </>
                    }
                  </tr>
                </thead>
                <tbody>
                  {product.sizeChart ? 
                    product.sizeChart.rows.map((row, idx) => (
                      <tr key={idx}>
                        {row.map((cell, cellIdx) => <td key={cellIdx}>{cell}</td>)}
                      </tr>
                    )) :
                    <>
                      <tr>
                        <td>S</td>
                        <td>34 - 36</td>
                        <td>28 - 30</td>
                        <td>14 - 14.5</td>
                        <td>32.5 - 33</td>
                      </tr>
                      <tr>
                        <td>M</td>
                        <td>38 - 40</td>
                        <td>32 - 34</td>
                        <td>15 - 15.5</td>
                        <td>33.5 - 34</td>
                      </tr>
                      <tr>
                        <td>L</td>
                        <td>42 - 44</td>
                        <td>36 - 38</td>
                        <td>16 - 16.5</td>
                        <td>34.5 - 35</td>
                      </tr>
                      <tr>
                        <td>XL</td>
                        <td>46 - 48</td>
                        <td>40 - 42</td>
                        <td>17 - 17.5</td>
                        <td>35 - 35.5</td>
                      </tr>
                      <tr>
                        <td>XXL</td>
                        <td>50 - 52</td>
                        <td>44 - 46</td>
                        <td>18 - 18.5</td>
                        <td>35.5 - 36</td>
                      </tr>
                    </>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreDetail; 